module.exports = __webpack_public_path__ + "img/jgy.16d04a6d.png";